// ********Save/Update button function API */
export const SaveTicketMasterDetails = async (VenderDesignation) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(VenderDesignation)

        }

        const response = await fetch(`${ApiURL}Ticket`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.data == "Record Already Exsist!") {
                return { success: false, data: responseData.data };
            } else if (responseData.data == "Code Already Exist!") {
                return { success: false, data: responseData.data };
            } else {
                return { success: true, data: responseData.data };
            }
        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("SaveTicketMasterDetails error:", error);
        return { success: false, data: "An error occurred." };
    }
};
// ********End of Save/Update button function API */

// ********Delete button function API */
export const DeleteTicketMasterDetails = async (rowDelete) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(rowDelete)
        };

        const response = await fetch(`${ApiURL}Common/Delete`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.data == "Cannot Delete, Record Already Used!") {
                return { success: false, data: responseData.data };

            } else {
                return { success: true, data: responseData.data }
            }
        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("DeleteTicketMasterDetails error:", error);
    }
};
// ********End of Delete button function API */

// *** Get and Set values when user search code function API*/
export const TicketMasterDetailsGetData = async (searchData) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }

        };
        const response = await fetch(`${ApiURL}Ticket/search/${searchData}`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success && responseData.data.length > 0) {
                return { success: true, data: responseData.data[0] };
            }
        } else {
            return { success: false, data: {} };
        }

        return { success: false, data: {} };

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}
// *** End of Get and Set values when user search code function API*/


// ********Item Bundle drop down function API */
export const SKU = async () => {

    let data = []
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL

    var requestOptions = {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
    };

    await fetch(`${ApiURL}Promotion/PromotionskuSelect`, requestOptions)
        .then(response => response.json())
        .then(result => {
            if (result.success) {
                data = result.data
            }
        }).catch(error => console.log('error', error));

    return data
}
 
// ********End of Item Bundle drop down function API */